<template>
    <h2 class="news-title" :class="{'news-subtitle': subtitle, 'news-title--no-top': margin.top}" :id="id">
        <slot>Heading content</slot>
    </h2>
</template>

<script>
    export default {
    	props: {
    		subtitle: Boolean,
            margin: {
    			type: Object,
                default () {
    				return {
						top: true,
						bottom: true
					}
                }
            },
            id: String
        }
    }
</script>

<style>
    .news-title {
        margin: 1rem 0;
        padding: 1rem;
        color: white;
        background: rgb(41, 41, 41);
        flex: 100%;
        font-size: 2.1rem;
    }
    .news-title.news-subtitle {
        margin:  1rem 0;
        font-size: 1.6rem;
    }
    .news-title.news-title--no-top {
        margin-top: 0;
    }
</style>


// WEBPACK FOOTER //
// news-heading.vue?0046458c